/**
 * Gets all focusable elements within a container
 * @param {HTMLElement} container - The container to search within
 * @return {NodeList} - A list of focusable elements
 */
function getFocusableElements(container) {
  return container.querySelectorAll(
    'a[href], button, textarea, input:not([type="hidden"]), select, [tabindex]:not([tabindex="-1"])',
  );
}

/**
 * Traps focus within the menu container
 *
 * @param {HTMLElement} menuContainer - The menu container element
 *
 * @return {Function} - The event handler function
 */
function trapFocus(menuContainer) {
  return function (event) {
    if (event.key !== 'Tab') {
      return;
    }
    const focusableElements = getFocusableElements(menuContainer);
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];
    const activeElement = menuContainer.ownerDocument.activeElement;
    if (event.shiftKey && activeElement === firstElement) {
      event.preventDefault();
      lastElement.focus();
    } else if (!event.shiftKey && activeElement === lastElement) {
      event.preventDefault();
      firstElement.focus();
    }
  };
}

/**
 * Closes open explore menu instance and optionally removes the active state from the header
 */
function closeMenu() {
  const btn = document.querySelector('.wp-block-rothschild-explore-menu-block__menu-button');

  btn.setAttribute('aria-expanded', false);
  document.body?.classList?.remove('explore-menu-is-active');
}

/**
 * Opens explore menu and adds the active state to the header
 *
 * @param {HTMLElement} menuButton    - The menu button element that triggered the menu
 * @param {HTMLElement} menuContainer - The menu container element
 */
function openMenu(menuButton, menuContainer) {
  menuButton.setAttribute('aria-expanded', true);

  // Focus the first focusable element in the menu
  const focusableElements = getFocusableElements(menuContainer);
  if (focusableElements.length > 0) {
    focusableElements[0].focus();
  }

  document.body?.classList?.add('explore-menu-is-active');
}

const menuButton = document.querySelector('.wp-block-rothschild-explore-menu-block__menu-button');
const menuId = menuButton.getAttribute('aria-controls');
const menuContainer = document.getElementById(menuId);
const closeIcon = document.querySelector('.wp-block-rothschild-explore-menu-block__close-icon');

menuContainer.addEventListener('keydown', trapFocus(menuContainer));

// handle menu button keydowns
menuContainer.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') {
    return;
  }

  closeMenu();
  menuButton.focus();
});

menuButton.addEventListener('click', (event) => {
  event.stopPropagation();

  const expanded = menuButton.getAttribute('aria-expanded') === 'true';

  if (!expanded) {
    openMenu(menuButton, menuContainer);
  } else {
    closeMenu();
  }
});

closeIcon.addEventListener('click', (event) => {
  event.stopPropagation();
  closeMenu();
  menuButton.focus();
});

// Stops mega menu from closing when clicking inside the explore menu container
menuContainer.addEventListener('click', (event) => {
  event.stopPropagation();
});

document.addEventListener('click', (event) => {
  if (event.target.closest('.wp-block-rothschild-explore-menu-block')) {
    return;
  }
  closeMenu();
});
